import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  portfolioCard: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '2rem',
    padding: '1.5rem',
    borderRadius: '0.4rem',
    border: `0.1rem solid ${colors.neutral[300]}`,
    boxShadow: boxShadows.light[2],
  },
  portfolioName: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    margin: 0,
    color: colors.neutral[700],
  },
  logo: {
    width: 'auto',
    height: '2rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
